document.addEventListener('DOMContentLoaded', function() {
  const FREE_SHIPPING_THRESHOLD = 500000; // 5,000円（センター単位）
  
  // 関連商品を表示する関数
  function displayRelatedProducts() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // カートが空の場合は非表示
        if (cart.items.length === 0) {
          hideRelatedProducts();
          return;
        }
        
        // 送料無料金額をチェック
        const currentTotal = cart.total_price;
        const remainingAmount = FREE_SHIPPING_THRESHOLD - currentTotal;
        
        // 送料無料金額に達している場合は関連商品を非表示
        if (remainingAmount <= 0) {
          hideRelatedProducts();
          showThankYouMessage();
          return;
        }
        
        // 4,200円未満の場合も非表示
        if (currentTotal < 420000) { // 4200円（単位は1/100）
          hideRelatedProducts();
          return;
        }
        
        // 4,200円〜4,999円のときだけ：表示処理へ進む
        displayShippingNoticeAndRelatedProducts(remainingAmount, cart);
        
        // カート内商品のタグとコレクションを収集
        const cartProductHandles = cart.items.map(item => item.handle);
        const productTags = new Set();
        const productTypes = new Set();
        
        // 各商品の詳細情報を取得
        const productPromises = cart.items.map(item => 
          fetch(`/products/${item.handle}.js`).then(res => res.json())
        );
        
        Promise.all(productPromises)
          .then(products => {
            // タグとタイプを収集
            products.forEach(product => {
              if (product.tags) product.tags.forEach(tag => productTags.add(tag));
              if (product.product_type) productTypes.add(product.product_type);
            });
            
            // 関連商品を検索
            return searchRelatedProducts(Array.from(productTags), Array.from(productTypes), cartProductHandles);
          })
          .then(relatedProducts => {
          });
      })
      .catch(error => {
        console.error('関連商品の取得に失敗しました:', error);
      });
  }
  
  // 送料無料表示と関連商品を同時に表示する関数
  function displayShippingNoticeAndRelatedProducts(remainingAmount, cart) {
    // カート内商品のタグとコレクションを収集
    const cartProductHandles = cart.items.map(item => item.handle);
    const productTags = new Set();
    const productTypes = new Set();
    // ▼▼▼ この部分が新しく入れるコード ▼▼▼
    fetch('/collections/recommend/products.json?limit=12')
    .then(res => {
      if (!res.ok) throw new Error('Collection not found');
      return res.json();
    })
    .then(data => {
      const relatedProducts = data.products
        // カート内商品・売り切れ商品は除外
        .filter(product => {
          const isInCart = cartProductHandles.includes(product.handle);
          const isSoldOut = product.variants.every(variant => variant.available === false);
          return !isInCart && !isSoldOut;
        })
        .slice(0, 5); // 最大表示数など調整

      // ここで表示関数呼び出し（※この関数は既存のものでOK）
      renderShippingNoticeAndRelatedProducts(remainingAmount, relatedProducts, cart.total_price);
    })
    .catch(error => {
      console.error('おすすめ商品の取得に失敗しました:', error);
    });
    // ▲▲▲ ここまで差し替えコード ▲▲▲
    
    // // 各商品の詳細情報を取得
    // const productPromises = cart.items.map(item => 
    //   fetch(`/products/${item.handle}.js`).then(res => res.json())
    // );
    
    // Promise.all(productPromises)
    //   .then(products => {
    //     // タグとタイプを収集
    //     products.forEach(product => {
    //       if (product.tags) product.tags.forEach(tag => productTags.add(tag));
    //       if (product.product_type) productTypes.add(product.product_type);
    //     });
        
    //     // 関連商品を検索
    //     return searchRelatedProducts(Array.from(productTags), Array.from(productTypes), cartProductHandles);
    //   })
    //   .then(relatedProducts => {
    //     renderShippingNoticeAndRelatedProducts(remainingAmount, relatedProducts, cart.total_price);
    //   });
  }
  
  // 関連商品を検索する関数
  function searchRelatedProducts(tags, types, excludeHandles) {
    // まず人気商品（ベストセラー）を取得を試行
    return fetchProductsByCollection(excludeHandles)
      .then(products => {
        if (products.length > 0) {
          return products;
        }
        // 失敗した場合はタグベースで検索
        return fetchProductsByTags(tags, excludeHandles);
      })
      .catch(() => {
        // 最終的なfallback: 新着商品を取得
        return fetchRecentProducts(excludeHandles);
      });
  }
  
  // コレクションから商品を取得
  function fetchProductsByCollection(excludeHandles) {
    // 複数のコレクションを試行
    const collections = ['all', 'best-sellers', 'featured-products', 'popular'];
    
    function tryCollection(index = 0) {
      if (index >= collections.length) {
        return Promise.resolve([]);
      }
      
      return fetch(`/collections/${collections[index]}/products.json?limit=12`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Collection ${collections[index]} not found`);
          }
          return response.json();
        })
        .then(data => {
          const products = data.products
            .filter(product => !excludeHandles.includes(product.handle))
            .slice(0, 5);
          
          if (products.length > 0) {
            return products;
          }
          // 商品が見つからない場合は次のコレクションを試行
          return tryCollection(index + 1);
        })
        .catch(() => {
          // エラーが発生した場合も次のコレクションを試行
          return tryCollection(index + 1);
        });
    }
    
    return tryCollection();
  }
  
  // タグベースで商品を検索
  function fetchProductsByTags(tags, excludeHandles) {
    if (!tags || tags.length === 0) {
      return Promise.resolve([]);
    }
    
    // 最も一般的なタグを使用して検索
    const searchTag = tags[0];
    const searchQuery = searchTag.replace(/[^a-zA-Z0-9\s]/g, '').trim();
    
    if (!searchQuery) {
      return Promise.resolve([]);
    }
    
    return fetch(`/search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product&resources[limit]=8`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Search API failed');
        }
        return response.json();
      })
      .then(data => {
        if (data.resources && data.resources.results && data.resources.results.products) {
          return data.resources.results.products
            .filter(product => !excludeHandles.includes(product.handle))
            .slice(0, 5);
        }
        return [];
      })
      .catch(() => {
        return [];
      });
  }
  
  // 新着商品を取得（最終fallback）
  function fetchRecentProducts(excludeHandles) {
    return fetch('/products.json?limit=12&sort_by=created-descending')
      .then(response => {
        if (!response.ok) {
          // 通常の商品一覧APIも失敗した場合
          return fetch('/collections/all/products.json?limit=12')
            .then(res => res.json());
        }
        return response.json();
      })
      .then(data => {
        const products = (data.products || [])
          .filter(product => !excludeHandles.includes(product.handle))
          .slice(0, 5);
        
        // それでも商品が取得できない場合のダミーデータ
        if (products.length === 0) {
          console.warn('関連商品を取得できませんでした');
          return [];
        }
        
        return products;
      })
      .catch(error => {
        console.error('商品取得でエラーが発生しました:', error);
        return [];
      });
  }
  
  // 送料無料表示と関連商品を同時に描画する関数
  function renderShippingNoticeAndRelatedProducts(remainingAmount, products, currentTotal) {
    let relatedContainer = document.querySelector('.cart-related-products');
    
    if (!relatedContainer) {
      relatedContainer = document.createElement('div');
      relatedContainer.className = 'cart-related-products';
      
      // カートページに挿入
      const cartForm = document.querySelector('form[action="/cart"]');
      if (cartForm) {
        cartForm.appendChild(relatedContainer);
      }
      
      // ドロワーカートに挿入
      const cartDrawer = document.querySelector('.cart-drawer') || document.querySelector('[data-cart-drawer]');
      if (cartDrawer) {
        cartDrawer.appendChild(relatedContainer);
      }
    }
    
    relatedContainer.style.display = 'block';
    
    // 送料無料表示部分
    const remainingAmountFormatted = (remainingAmount / 100).toLocaleString();
    const progressPercentage = (currentTotal / FREE_SHIPPING_THRESHOLD) * 100;
    
    const shippingNoticeHTML = `
      <div class="shipping-notice-content" style="
        text-align:center;">
        <div class="shipping-notice-content-title">
          あと、<span style="color:#C43232;padding-right:3px;display:inline-block;margin-left:-8px;">${remainingAmountFormatted}円</span>ご購入で送料無料！
        </div>
          <div style="
            background: linear-gradient(90deg, #fff200, #ffed4e);
            height: 100%;
            width: ${Math.min(progressPercentage, 100)}%;
            border-radius: 5px;
            transition: width 0.5s ease;
            box-shadow: 0 0 10px rgba(255, 242, 0, 0.5);
          "></div>
        </div>
      </div>
    `;
    
    // 関連商品が存在する場合のみ表示
    let relatedProductsHTML = '';
    if (products && products.length > 0) {
      const productsHTML = products.map(product => {
        const price = product.variants[0].price ? product.variants[0].price : '';
        const comparePrice = product.compare_at_price && product.compare_at_price > product.price 
          ? (product.compare_at_price / 100).toLocaleString() 
          : '';
        
        return `
          <div class="related-product-item" style="" onmouseover="" 
             onmouseout=""
             onclick="window.location.href='/products/${product.handle}'">
            <div class="product-image" style="margin-bottom: 8px;">
              <img src="${product.images[0].src || '/assets/no-image.png'}" 
                   alt="${product.title}" 
                   style="width: 100%; object-fit: cover; border-radius: 4px;">
            </div>
            <div class="product-title" style="
              font-size: 13px;
              font-weight: bold;
              margin-bottom: 6px;
              line-height: 1.3;
              height: 32px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            ">${product.title}</div>
            <div class="product-price" style="font-weight: bold;">
              ${comparePrice ? `<span style="text-decoration: line-through;font-size: 12px; margin-right: 4px;">¥${comparePrice}</span>` : ''}
              ${price}円
            </div>
            <a class="add-related-product" 
                    style="
                      background: #C43232;
                      color: white;
                      border: none;
                      font-weight: bold;
                      padding: 1px 12px;
                      border-radius: 4px;
                      font-size: 12px;
                      margin-top: 8px;
                      cursor: pointer;
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 100%;
                      height: 4.8rem;
                      transition: background 0.2s ease;
                    " href="https://zakkokumai.com/cart/add?id=${product.variants[0].id}&quantity=1">カートに追加
            </a>
            <button class="add-related-product" 
                    onclick="event.stopPropagation(); addRelatedToCart('${product.variants[0].id}')" 
                    style="
                    display: none;
                      background: #C43232;
                      color: white;
                      border: none;
                      font-weight: bold;
                      padding: 1px 12px;
                      border-radius: 4px;
                      font-size: 12px;
                      margin-top: 8px;
                      cursor: pointer;
                      width: 100%;
                      transition: background 0.2s ease;
                    ">
              カートに追加
            </button>
          </div>
        `;
      }).join('');
      
      relatedProductsHTML = `
        <div style="margin-top: 8px;">
          <div class="related-products-grid" style="
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 12px;
            max-width: 100%;
          ">
            ${productsHTML}
          </div>
        </div>
      `;
    }
    
    // 全体を結合して表示
    relatedContainer.innerHTML = `
      <div class="cart-related-products-pop">
        <div class="cart-related-products-pop-inner">
        ${shippingNoticeHTML}
        ${relatedProductsHTML}
        </div>
      </div>
    `;
  }
  
  // 関連商品をカートに追加する関数
  window.addRelatedToCart = function(variantId) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // カート更新通知
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // 成功メッセージ表示
      showAddToCartMessage('商品をカートに追加しました！');
      
      // 関連商品を再表示
      setTimeout(displayRelatedProducts, 500);
    })
    .catch(error => {
      console.error('カートへの追加に失敗しました:', error);
      // showAddToCartMessage('エラーが発生しました', true);
    });
  };
  
  // カート追加メッセージを表示
  // function showAddToCartMessage(message, isError = false) {
  //   const toast = document.createElement('div');
  //   toast.style.cssText = `
  //     position: fixed;
  //     top: 20px;
  //     right: 20px;
  //     background: ${isError ? '#ff6b6b' : '#4CAF50'};
  //     color: white;
  //     padding: 12px 20px;
  //     border-radius: 6px;
  //     z-index: 10000;
  //     font-size: 14px;
  //     box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  //     animation: slideIn 0.3s ease;
  //   `;
  //   toast.textContent = message;
    
  //   // アニメーション用CSS
  //   const style = document.createElement('style');
  //   style.textContent = `
  //     @keyframes slideIn {
  //       from { transform: translateX(100%); opacity: 0; }
  //       to { transform: translateX(0); opacity: 1; }
  //     }
  //   `;
  //   document.head.appendChild(style);
    
  //   document.body.appendChild(toast);
    
  //   setTimeout(() => {
  //     toast.remove();
  //   }, 3000);
  // }
  
  // 関連商品を非表示にする関数
  function hideRelatedProducts() {
    const relatedContainer = document.querySelector('.cart-related-products');
    if (relatedContainer) {
      relatedContainer.style.display = 'none';
    }
  }
  
  // 送料無料達成時のお礼メッセージを表示
  // function showThankYouMessage() {
  //   let relatedContainer = document.querySelector('.cart-related-products');
    
    // if (!relatedContainer) {
    //   relatedContainer = document.createElement('div');
    //   relatedContainer.className = 'cart-related-products';
      
    //   // カートページに挿入
    //   const cartForm = document.querySelector('form[action="/cart"]');
    //   if (cartForm) {
    //     cartForm.appendChild(relatedContainer);
    //   }
      
    //   // ドロワーカートに挿入
    //   const cartDrawer = document.querySelector('.cart-drawer') || document.querySelector('[data-cart-drawer]');
    //   if (cartDrawer) {
    //     cartDrawer.appendChild(relatedContainer);
    //   }
    // }
    
    // お礼メッセージを表示
  //   relatedContainer.style.display = 'block';
  //   relatedContainer.innerHTML = `
  //     <div style="margin-top: 32px; padding: 24px; text-align: center; background: linear-gradient(135deg, #4CAF50, #45a049); border-radius: 12px; color: white; box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);">
  //       <div style="font-size: 24px; margin-bottom: 8px;">🎉</div>
  //       <h3 style="font-size: 18px; margin-bottom: 8px; font-weight: 600;">
  //         送料無料でお届けします！
  //       </h3>
  //       <p style="font-size: 14px; opacity: 0.9; margin-bottom: 16px;">
  //         このままチェックアウトにお進みください
  //       </p>
  //     </div>
  //   `;
  // }
  
  // 初期表示
  displayRelatedProducts();
  
  // カート更新時に関連商品も更新
  document.addEventListener('cart:updated', displayRelatedProducts);
  document.addEventListener('cart:changed', displayRelatedProducts);
  
  // DOM変更監視
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const cartElements = document.querySelectorAll('[data-cart-items], .cart-items');
        if (cartElements.length > 0) {
          setTimeout(displayRelatedProducts, 500);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
                          
});